import { render, staticRenderFns } from "./_promptDetailArticles.vue?vue&type=template&id=270ca8d4&"
import script from "./_promptDetailArticles.vue?vue&type=script&lang=js&"
export * from "./_promptDetailArticles.vue?vue&type=script&lang=js&"
import style0 from "./_promptDetailArticles.vue?vue&type=style&index=0&id=270ca8d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports